export const PROJECT_REGISTER_URL_PATTERN =
  /^(?=.+)(?:https?:\/\/)?(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,63}(?:[\/?#][^\s]+)?$/;

/** Quando `true`, Avançar/Registrar exigem campos válidos da etapa atual. */
export const PROJECT_REGISTER_ENFORCE_STEP_VALIDATION = true;

/** Campos obrigatórios por etapa (somente seções/campos com tag "Obrigatório" no layout). */
export const PROJECT_REGISTER_STEP_FIELDS: string[][] = [
  [
    'projectName',
    'registerCode',
    'projectStartDate',
    'baselineActivity',
    'generalDetails',
    'developerCompanyName',
    'developerCnpj',
    'developerEmail',
    'developerPhone',
  ],
  ['locations'],
  [
    'methodology',
    'ramComplianceReportLink',
    'ramComplianceReportDetail',
    // Opcionais (sem tag Obrigatório no layout): attachments, relevantDocumentationAdd, documentDescription
  ],
  ['odsNumbers', 'coBenefits'],
];
